export const environment = {
  production: true,
  admNome: 'Mega Administradora',
  apiUrl: 'https://api.g2saude.com.br/api/cliente',
  assets: 'mega',
  base: 'mega',
};
